<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Biểu phí ưu đãi</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.textSearch"
              class="form-control f12 hc-37 text-search"
              placeholder="Email/Tên MC/Mã biểu phí"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDatePicker }} -
                  {{ picker.endDate | formatDatePicker }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2MultipleControl
              :settings="{ placeholder: 'Người tạo', multiple: false }"
              v-model="filters.createdBy"
              :options="dataManager"
            >
            </Select2MultipleControl>
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.status"
              :options="proposalFeeStatus"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(status)="{ item }">
                <b-badge :variant="getStatusBadge(item.status)">
                  {{ getStatusName(item.status) }}
                </b-badge>
              </template>
              <template #cell(merchant)="{ item }">
                <div>
                  <span><i class="bx bx-user"></i> </span>
                  <b-link size="sm">
                    {{ item.mcName || '-' }}
                  </b-link>
                </div>
                <div class="d-flex" style="gap: 3px; align-items: center">
                  <i class="bx bx-envelope"></i>
                  <a :href="`mailto:${item.email}`">{{ item.email }}</a>
                </div>
                <div class="mt-1">
                  <span class="text-muted">Sale CS: </span>
                  <span class="text-primary">{{ item.saleName }}</span>
                </div>
              </template>
              <template #cell(createdTime)="{ item }">
                <p>
                  <b class="text-muted">Tạo:</b>
                  {{ item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p>
                  <b class="text-muted">Cập nhật:</b>
                  {{ item.lastModifiedDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(action)="{ item }">
                <b-link
                  :href="`/proposal-fee/${item.id}`"
                  target="_blank"
                  style="color: #0056f6"
                  size="sm"
                >
                  <img
                    src="@/assets/img/circle-three-dots.svg"
                    alt="Circle with Three Dots"
                    style="width: 15px; height: 15px"
                  />
                  Chi tiết
                </b-link>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
            @change="handlePageChange"
          ></b-pagination>
        </div>
      </div>
    </div>

    <b-modal id="modal-noti" centered v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { getConfigProposalFee, getListProposalFee } from '@/services/merchant.service'
  import { StaffService } from '@/services/staff.service'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'code', label: 'Mã biểu phí' },
    { key: 'createdTime', label: 'Thời gian' },
    { key: 'merchant', label: 'Merchant' },
    { key: 'createdByName', label: 'Người tạo' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]

  const statusMapping = {
    NEW: 'primary',
    DRAFT: 'secondary',
    CANCELED: 'danger',
    LIVE: 'success',
  }

  export default {
    name: 'sticker-standee-cskh',
    mixins: [prepareQueryParamsMixin],
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        loading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataManager: [],
        filters: {
          textSearch: '',
          createdDate: '',
          createdBy: '',
          status: '',
          fromTimeComplete: '',
          toTimeComplete: '',
        },
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dateRange: {
          startDate: null,
          endDate: null,
        },
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        proposalFeeStatus: [],
      }
    },
    async created() {
      if (!this.dataPermission.includes('')) {
        await Promise.allSettled([this.fetchSuperiors(), this.getConfig(), this.fetchData()]).catch(
          e => console.log(e)
        )
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.replace('/')
          })
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
      getStatusName() {
        return id => {
          const status = this.proposalFeeStatus.find(status => status.id === id)
          return status ? status.text : 'Mới tạo'
        }
      },
      getStatusBadge() {
        return id => {
          const status = this.proposalFeeStatus.find(status => status.id === id)
          return status ? status.badge : 'primary'
        }
      },
    },
    methods: {
      async handlePageChange(page) {
        this.search.page = page
        await this.fetchData()
      },
      detail(id) {
        const routeData = this.$router.resolve({ path: `/proposal-fee/${id}` })
        window.open(routeData.href, '_blank')
      },
      transformDate() {
        this.filters.fromTimeComplete = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.filters.toTimeComplete = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        await this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.filters = {
          merchantName: '',
          saleIds: '',
          status: '',
          fromTimeComplete: '',
          toTimeComplete: '',
        }
        this.selected = []
        await this.fetchData()
      },
      async fetchSuperiors() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: JSON.parse(localStorage.getItem('userData')).userId,
          })
          const dat = data.data.map(e => {
            return { id: e.userId, text: e.name }
          })
          this.dataManager = [{ id: '0', text: 'Tất cả' }, ...dat]
        } catch (e) {
          this.showToastError(e.response?.data?.message ? e.response.data.message : e.message)
        }
      },
      async getConfig() {
        try {
          // this.loading = true
          const response = await getConfigProposalFee()
          if (response.code === 1000) {
            this.proposalFeeStatus = Object.keys(response.data.proposalFeeStatus).map(key => ({
              id: key,
              text: response.data.proposalFeeStatus[key],
              badge: statusMapping[key],
            }))

            this.proposalFeeStatus.unshift({ id: '0', text: 'Tất cả' })
          } else {
            this.showToastError(response.message || 'Có lỗi xảy ra')
          }
          // this.loading = false
        } catch (e) {
          this.showToastError(e.response?.data?.message ? e.response.data.message : e.message)
          // this.loading = false
        }
      },
      async fetchData() {
        try {
          this.tbLoading = true

          if (this.dateRange.startDate) {
            this.search.createdDateFrom = `${moment(this.dateRange.startDate).startOf('day').add(7, 'hours').toISOString()}`
          }
          if (this.dateRange.endDate) {
            this.search.createdDateTo = `${moment(this.dateRange.endDate).endOf('day').add(7, 'hours').toISOString()}`
          }

          const listKey = ['textSearch', 'createdBy', 'status']

          listKey.forEach(key => {
            if (this.filters[key] && this.filters[key] !== '0') {
              this.search[key] = this.filters[key]
            } else {
              delete this.search[key]
            }
          })

          const response = await getListProposalFee(this.search)

          if (response.code === 1000) {
            this.lists = response.data.proposalFees
            this.pagination.total = response.data.total
          } else {
            this.showToastError(response.message || 'Có lỗi xảy ra')
          }
          this.tbLoading = false
        } catch (e) {
          this.showFailMx(e.response?.data?.message ? e.response.data.message : e.message)
          this.tbLoading = false
        } finally {
          this.tbLoading = false
        }
      },
    },
  }
</script>

<style>
  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px !important;
  }
</style>
